import React,  { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { months } from "../../../../../../Utils/months";
import { renderDollar, renderCurrency, renderNumberKG, renderNumberKGDisabled, renderDollarDisabled, renderCurrencyDisabled } from "../../../../../../Utils/renderField/renderField";

const LatexTable = (props) => {

    const { fields, change, data_solido, currency } = props;

    const solido_data = (data_solido) ? data_solido : {};

    if (!solido_data) {
        return null;
    }

    const calculateMonthlyValuesSolido = () => {
        const tempData = {};
        const getNumber = (v) => parseFloat(v) || 0;

        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const prevMonth = i > 0 ? months[i - 1] : null;

            if (!solido_data[month]) continue;

            const current = solido_data[month];
            const AjustesDRCCompVsDRCProc = current["ajustes_DRC_comp_vs_DRC_proc"] || {};
            const SkimParaSolidosAjuste = current["skim_para_solidos"] || {};
            const CoaguloLavadoPilas = current["coagulo_lavado_pilas/centrífugas"] || {};
            const CoaguloDeTrampas = current["coagulo_de_trampas"] || {};
            const CoaguloCentrifugado = current["coagulo_centrifugado"] || {};
            const SkimParaSolidos = current["skim_para_solidos"] || {};
            const ProduccionFinca = current["produccion_finca"] || {};
            const ComprasImportadas = current["compras_importadas"] || {};
            const ComprasCrodExportador = current["compras_prod_exportador"] || {};
            const ComprasDelMes = current["compras_del_mes"] || {};

            // Heredar inventario inicial
            let inventarioInicial = {};
            if (i === 0) {
                inventarioInicial = current.inventario_inicial || {};
            } else {
                const prevData = tempData[prevMonth] || solido_data[prevMonth] || {};
                inventarioInicial = prevData.inventario_final || {};
            }

            // Calcular exactamente igual que el backend
            const totalKgsSecos = parseFloat((
                getNumber(inventarioInicial.kgs_secos) +
                getNumber(AjustesDRCCompVsDRCProc.kgs_secos) +
                getNumber(SkimParaSolidosAjuste.kgs_secos) +
                getNumber(CoaguloLavadoPilas.kgs_secos) +
                getNumber(CoaguloDeTrampas.kgs_secos) +
                getNumber(CoaguloCentrifugado.kgs_secos) +
                getNumber(SkimParaSolidos.kgs_secos) +
                getNumber(ProduccionFinca.kgs_secos) +
                getNumber(ComprasImportadas.kgs_secos) +
                getNumber(ComprasCrodExportador.kgs_secos) +
                getNumber(ComprasDelMes.kgs_secos)
            ).toFixed(2));

            const totalValorTotal = parseFloat((
                getNumber(inventarioInicial.valor_total) +
                getNumber(AjustesDRCCompVsDRCProc.valor_total) +
                getNumber(SkimParaSolidosAjuste.valor_total) +
                getNumber(CoaguloLavadoPilas.valor_total) +
                getNumber(CoaguloDeTrampas.valor_total) +
                getNumber(CoaguloCentrifugado.valor_total) +
                getNumber(SkimParaSolidos.valor_total) +
                getNumber(ProduccionFinca.valor_total) +
                getNumber(ComprasImportadas.valor_total) +
                getNumber(ComprasCrodExportador.valor_total) +
                getNumber(ComprasDelMes.valor_total)
            ).toFixed(2));

            const costoKgSecoPromedio = totalKgsSecos > 0 ? parseFloat((totalValorTotal / totalKgsSecos).toFixed(5)) : 0;

            tempData[month] = {
                inventario_inicial: {
                    kgs_secos: getNumber(inventarioInicial.kgs_secos),
                    costo_kg_seco: getNumber(inventarioInicial.costo_kg_seco),
                    valor_total: parseFloat((getNumber(inventarioInicial.kgs_secos) * getNumber(inventarioInicial.costo_kg_seco)).toFixed(2))
                },
                skim_para_solidos: {
                    valor_total: parseFloat((getNumber(SkimParaSolidosAjuste.kgs_secos) * getNumber(SkimParaSolidosAjuste.costo_kg_seco)).toFixed(2))
                },
                compras_importadas: {
                    valor_total: parseFloat((getNumber(ComprasImportadas.kgs_secos) * getNumber(ComprasImportadas.costo_kg_seco)).toFixed(2))
                },
                compras_prod_exportador: {
                    valor_total: parseFloat((getNumber(ComprasCrodExportador.kgs_secos) * getNumber(ComprasCrodExportador.costo_kg_seco)).toFixed(2))
                },
                cto_promedio_del_inven: {
                    kgs_secos: totalKgsSecos,
                    valor_total: totalValorTotal,
                    costo_kg_seco: costoKgSecoPromedio
                },
                salidas_a_produccion_latex: {
                    kgs_secos: totalKgsSecos,
                    valor_total: totalValorTotal,
                    costo_kg_seco: costoKgSecoPromedio
                },
                inventario_final: {
                    kgs_secos: 0,
                    valor_total: 0,
                    costo_kg_seco: costoKgSecoPromedio
                }
            };
        }

        // Aplicar los cambios al formulario
            
        for (let i = 0 ; i < months.length; i++) {
            const month = months[i];
            const temp = tempData[month];
            if (!temp) return;

            change(`solido_data.${month}.inventario_inicial.kgs_secos`, temp.inventario_inicial.kgs_secos);
            change(`solido_data.${month}.inventario_inicial.costo_kg_seco`, temp.inventario_inicial.costo_kg_seco);
            change(`solido_data.${month}.inventario_inicial.valor_total`, temp.inventario_inicial.valor_total);

            change(`solido_data.${month}.skim_para_solidos.valor_total`, temp.skim_para_solidos.valor_total);
            change(`solido_data.${month}.compras_importadas.valor_total`, temp.compras_importadas.valor_total);
            change(`solido_data.${month}.compras_prod_exportador.valor_total`, temp.compras_prod_exportador.valor_total);

            change(`solido_data.${month}.cto_promedio_del_inven.kgs_secos`, temp.cto_promedio_del_inven.kgs_secos);
            change(`solido_data.${month}.cto_promedio_del_inven.valor_total`, temp.cto_promedio_del_inven.valor_total);
            change(`solido_data.${month}.cto_promedio_del_inven.costo_kg_seco`, temp.cto_promedio_del_inven.costo_kg_seco);

            change(`solido_data.${month}.salidas_a_produccion.kgs_secos`, temp.salidas_a_produccion_latex.kgs_secos);
            change(`solido_data.${month}.salidas_a_produccion.valor_total`, temp.salidas_a_produccion_latex.valor_total);
            change(`solido_data.${month}.salidas_a_produccion.costo_kg_seco`, temp.salidas_a_produccion_latex.costo_kg_seco);

            change(`solido_data.${month}.inventario_final.kgs_secos`, temp.inventario_final.kgs_secos);
            change(`solido_data.${month}.inventario_final.valor_total`, temp.inventario_final.valor_total);
            change(`solido_data.${month}.inventario_final.costo_kg_seco`, temp.inventario_final.costo_kg_seco);
        };
    };

    const executedRef = useRef(false);

    useEffect(() => {
        if (executedRef.current) return;
    
        const hasLatexData = months.some((month) => {
            const data = solido_data[month];
            return data && Object.keys(data).length > 0;
        });
    
        if (hasLatexData) {
            calculateMonthlyValuesSolido();
            executedRef.current = true; 
        }
    }, [solido_data]);


    const rowDescriptionClassName = "text-left table-fixed-cell-left-0 bg-white text-nowrap tr--border-left tr--border-right";

    return (
        <div className="reports__table-bg">
            <div className="reports-table__container">
                <table className="table mb-0 text-center min-w-500">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-left table-fixed-cell-left-0 tr--border-top tr--border-left td--shadow-right">&nbsp;</th>
                            {months.map((_, index) => (
                                <th key={index} colSpan={3} className={`th--border ${index === 0 ? "tr--no-border-left" : ""}`}>{index + 1}</th>
                            ))}
                        </tr>
                        <tr className="tr--no-radius tr--border-top">
                            {months.map((_, index) => (
                                <React.Fragment key={index}>
                                    <th className={index > 0 ? "tr--border-left" : ""}>Kgs Secos</th>
                                    <th>Costo Kg Sec</th>
                                    <th className="tr--border-right">Valor total</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {/* 🔹 Inventario Inicial */}
                        <tr className="tr--border-top">
                            <td className={rowDescriptionClassName}>Inventario Inicial</td>
                            {months.map((month, index) => {
                                // Si no es enero, obtener el Inventario Final del mes anterior
                                const previousMonth = index > 0 ? months[index - 1] : null;
                                const monthClass = index % 2 === 0 ? "" : "month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`solido_data.${month}.inventario_inicial.kgs_secos`}
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                    isReport
                                                    onBlur={calculateMonthlyValuesSolido}
                                                />
                                            ) : (
                                                <Field
                                                    name={`solido_data.${previousMonth}.inventario_final.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`solido_data.${month}.inventario_inicial.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    decimalScale={5}
                                                    placeholder="$ 0.00000"
                                                    onBlur={calculateMonthlyValuesSolido}
                                                />
                                            ) : (
                                                <Field
                                                    name={`solido_data.${previousMonth}.inventario_final.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    decimalScale={5}
                                                    placeholder="$ 0.00"
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`solido_data.${month}.inventario_inicial.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                />
                                            ) : (
                                                <Field
                                                    name={`solido_data.${previousMonth}.inventario_final.valor_total`}
                                                    type="text"
                                                    component={renderDollarDisabled}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                />
                                            )}
                                        </td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                        {/* 🔹 Compras Prod/Exp */}
                        {[
                            { label: "(-) Ajustes DRC comp vs DRC proc.", key: "ajustes_DRC_comp_vs_DRC_proc" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? "" : "month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        <tr>
                            <td className={rowDescriptionClassName}>(+) SKIM para sólidos</td>
                            {months.map((month, index) => {
                                const monthClass = index % 2 === 0 ? "" : "month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.skim_para_solidos.kgs_secos`}
                                                component={renderNumberKG}
                                                className="form-control"
                                                placeholder="0.00 kg"
                                                isReport
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.skim_para_solidos.costo_kg_seco`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                className="form-control"
                                                decimalScale={5}
                                                placeholder="$ 0.00"
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`solido_data.${month}.skim_para_solidos.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder='$0.00'
                                            />
                                        </td>
                                    </React.Fragment>
                                )
                            })}
                        </tr>

                        {[
                            { label: "(+) Coàgulo lavado pilas/centrifugas", key: "coagulo_lavado_pilas/centrífugas" },
                            { label: "(+) Coàgulos de trampas", key: "coagulo_de_trampas" },
                            { label: "(+) Coàgulos centrifugado", key: "coagulo_centrifugado" },
                            { label: "(+) Produccion Finca", key: "produccion_finca" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {

                                    const monthClass = index % 2 === 0 ? "" : "month-dark";
                                    return (
                                        <React.Fragment key={index} >
                                            <td className={monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                }

                                )}
                            </tr>
                        ))}

                        <tr>
                            <td className={rowDescriptionClassName}>(+) Compras Importadas</td>
                            {months.map((month, index) => {
                                const monthClass = index % 2 === 0 ? "" : "month-dark";
                                return (
                                    <React.Fragment key={index}>

                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.compras_importadas.kgs_secos`}
                                                type="text"
                                                component={renderNumberKG}
                                                className="form-control"
                                                placeholder="0.00 kg"
                                                isReport
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.compras_importadas.costo_kg_seco`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                className="form-control"
                                                placeholder="$ 0.00"
                                                decimalScale={5}
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`solido_data.${month}.compras_importadas.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder='$0.00'
                                            />
                                        </td>
                                    </React.Fragment>
                                )
                            })}
                        </tr>

                        <tr>
                            <td className={rowDescriptionClassName}>(+) Compras Prod-Exportador</td>
                            {months.map((month, index) => {
                                const monthClass = index % 2 === 0 ? "month-light" : "month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.compras_prod_exportador.kgs_secos`}
                                                type="text"
                                                component={renderNumberKG}
                                                className="form-control"
                                                placeholder="0.00 kg"
                                                isReport
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass}>
                                            <Field
                                                name={`solido_data.${month}.compras_prod_exportador.costo_kg_seco`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                className="form-control"
                                                placeholder="$ 0.00"
                                                decimalScale={5}
                                                onBlur={calculateMonthlyValuesSolido}
                                            />
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`solido_data.${month}.compras_prod_exportador.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder='$0.00'
                                            />
                                        </td>
                                    </React.Fragment>
                                )
                            })}
                        </tr>
                        {[
                            { label: "(+) Compras del mes", key: "compras_del_mes", style:''},
                            { label: "Cto. Promedio del Inven. Total", key: "cto_promedio_del_inven", style: ' celda-totales ' },
                            { label: "Salidas a producción sólido", key: "salidas_a_produccion", style:'' },
                            { label: "Inventario Final", key: "inventario_final", style: ' celda-totales ' }

                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName + row.style}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

const formName = 'CostosMPForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const data_solido = selector(state, 'solido_data');
    return {
        data_solido,
    };
};


export default connect(mapStateToProps)(LatexTable);
